var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{ref:"map",attrs:{"center":_vm.center,"zoom":this.zoomLevel,"options":_vm.options},on:{"dragend":_vm.updateCenter}},[_c('map-marker')],1)}
var staticRenderFns = []

export { render, staticRenderFns }